import i18n from "@/i18n";
import moment from "moment";

export const activityLogsFilters = [
    {
        key: "user",
        label: i18n.t("users.user")
    },
    {
        key: "impersonatingUser",
        label: i18n.t("users.impersonate")
    },
    {
        key: "action",
        label: i18n.t("userActvityLog.action")
    },
    {
        key: "type",
        label: i18n.t("userActvityLog.type")
    },
    {
        key: "target",
        label: i18n.t("userActvityLog.target")
    },
    {
        key: "targetId",
        label: i18n.t("userActvityLog.targetId")
    },
    {
        key: "related",
        label: i18n.t("userActvityLog.related")
    },
    {
        key: "timeStampOnUtc",
        label: i18n.t("common.createdOn"),
        sortable: true,
        formatter: formatDate,
        sortDirection: "desc"
    }
];

// helper methods

function formatDate(date: string) {
    return moment(date).format("MMMM Do YYYY, h:mm:ss a");
}
